import { cn } from '@/shared/utils/cn';

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'mobile' | 'narrow' | 'medium' | 'wide';
  noPadding?: boolean;
}

const maxWidthVariants = {
  mobile: 'max-w-[420px]',
  narrow: 'max-w-2xl',
  medium: 'max-w-3xl',
  wide: 'max-w-4xl',
};

/**
 * Consistent page container for mobile-first layout.
 * Default: mobile (max-w-[420px]) for consistent narrow layout across app.
 */
export const PageContainer = ({
  children,
  className,
  maxWidth = 'mobile',
  noPadding = false,
}: PageContainerProps) => {
  return (
    <div
      className={cn(
        'mx-auto w-full',
        maxWidthVariants[maxWidth],
        !noPadding && 'px-6 md:px-8',
        className,
      )}
    >
      {children}
    </div>
  );
};
